var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoArrowDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 8.43333L2.7 5.1C2.20557 4.44076 2.67596 3.5 3.5 3.5L8.5 3.5C9.32405 3.5 9.79443 4.44076 9.3 5.1L6.8 8.43333C6.4 8.96667 5.6 8.96667 5.2 8.43333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowDropdown);
export default __webpack_public_path__ + "static/media/ico_arrow_dropdown.fd30eff659f2395cb6616deea3b39e6b.svg";
export { ForwardRef as ReactComponent };